import { render, staticRenderFns } from "./DetailsSettings.vue?vue&type=template&id=4332120c&scoped=true&"
import script from "./DetailsSettings.vue?vue&type=script&lang=ts&"
export * from "./DetailsSettings.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsSettings.vue?vue&type=style&index=0&id=4332120c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332120c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSwitch})
